import React from 'react'

export const CountryOptions = ({ countryList, selectedCountryId }) => {
  if (countryList != null && countryList.length > 0) {
    return countryList.map(data => {
      if (selectedCountryId === data.Id) {
        return <option value={data.Id} selected={selectedCountryId === data.Id}>{data.Name}</option>
      } else {
        return <option value={data.Id}>{data.Name}</option>
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Country.js